"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var strategy_1 = __importDefault(require("./strategy"));
var StrategyBuilder = /** @class */ (function () {
    function StrategyBuilder(transport) {
        this.transport = transport;
        this.opts = {
            delay: 0,
            backoff: 0,
        };
    }
    StrategyBuilder.prototype.withDelay = function (delay) {
        this.opts.delay = delay;
        return this;
    };
    StrategyBuilder.prototype.withBackoff = function (backoff) {
        this.opts.backoff = backoff;
        return this;
    };
    StrategyBuilder.prototype.build = function () {
        return new strategy_1.default(this.transport, this.opts);
    };
    return StrategyBuilder;
}());
exports.StrategyBuilder = StrategyBuilder;
function aStrategyBuilder(transport) {
    return new StrategyBuilder(transport);
}
exports.default = aStrategyBuilder;
//# sourceMappingURL=strategy-builder.js.map